import React from 'react';
import styled from 'styled-components';
import { type SankeyLink } from '@src/pages/journey-map/types';
import { parseNumToPercentage } from '@src/shared/utils';
import { readableTime } from '@src/pages/journey-map/utils/formatTime';
import { useDatasetStore } from '@src/shared/store';

interface TooltipProps {
  x: number;
  y: number;
  visible?: boolean;
  children?: React.ReactNode;
}

const Tooltip = styled.div<TooltipProps>`
  position: absolute;
  left: ${(props) => props.x}px;
  top: ${(props) => props.y}px;
  background: rgb(255 255 255 / 95%);
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 2px 8px rgb(0 0 0 / 15%);
  font-size: 12px;
  color: #333;
  white-space: nowrap;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  transition: opacity 0.2s ease;
  pointer-events: none;
  z-index: 99;
  min-width: 250px;
  max-width: 600px;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 14px;
  color: #1890ff;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px;
  align-items: center;
`;

const Label = styled.div`
  color: #666;
  font-size: 13px;
`;

const Value = styled.div`
  color: #262626;
  font-size: 13px;
  font-weight: 500;
`;

const NWRsContainer = styled.div`
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
`;

const NWRsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-height: 300px;
  overflow-y: scroll;
`;

const NWRTag = styled.div`
  background: #f5f5f5;
  padding: 4px 8px;
  border-radius: 4px;
  color: #595959;
  font-size: 12px;
`;

interface LinkTooltipProps {
  link: SankeyLink;
  isVisible: boolean;
  x: number;
  y: number;
}

const LinkTooltip = ({ link, isVisible, x, y }: LinkTooltipProps) => {
  const { sankey } = useDatasetStore();
  const pair = sankey.find(
    (i) => i.start_event.name === link.source.name && i.end_event.name === link.target.name,
  );
  const nwrs = pair?.nwrs;

  return (
    <Tooltip x={x} y={y} visible={isVisible}>
      <Title>Flow Details</Title>
      <Grid>
        {/* <Label>Value:</Label>
        <Value>{link.value}</Value> */}
        <Label>From:</Label>
        <Value>{link.source.name}</Value>
        <Label>To:</Label>
        <Value>{link.target.name}</Value>
      </Grid>
      {/* <NWRsContainer>
        <div style={{ color: '#666', fontSize: '13px', marginBottom: '8px' }}>Related NWRs:</div>
        <NWRsList>
          {nwrs &&
            nwrs.length > 0 &&
            nwrs.map((nwr, index) => (
              <NWRTag as={'div'} key={index}>
                {nwr}
              </NWRTag>
            ))}
        </NWRsList>
      </NWRsContainer> */}
    </Tooltip>
  );
};

export default LinkTooltip;
